import React from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import TechWaves from './TechWaves';
import { useModal } from '../context/ModalContext';

const CTA = () => {
  const { openModal } = useModal();
  return (
    <section className="cta-section">
      <TechWaves />
      <div className="container cta-container">
        <div className="cta-content">
          <h2>Let's Build Something That Matters</h2>
          <p>Partner with Le-Ma Systems to design and develop solutions that move your business forward.</p>
        </div>
        <div>
          <button className="btn btn-primary btn-large" onClick={openModal}>
            Start a Project <ArrowForwardIcon style={{ marginLeft: '8px' }} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTA;
